<template>
    <div class="main">

        <c-panel>
            <el-row :gutter="10">
                <el-col :xs="24" :sm="24" :md="24">
                    <label>Relatórios</label>
                    <el-select v-model="tipo">
                        <el-option :key="1" label="FREQUÊNCIA QUANTITATIVO" :value="1"></el-option>
                        <el-option :key="2" label="FREQUÊNCIA OBSERVAÇÃO" :value="2"></el-option>
                    </el-select>
                </el-col>
            </el-row>
        </c-panel>

        <div class="u-mt-10">
            <quantitativo v-if="tipo == 1"></quantitativo>
            <observacao v-if="tipo == 2"></observacao>
        </div>

        
    </div>
</template>
<script>

import quantitativo from "./quantitativo"
import observacao from "./observacao"

export default {
    data: () => ({
        tipo: 1        
    }),
    mounted () {

    },
    methods: {     
        text(){
            
            
        }
    },
    components:{ quantitativo, observacao }
}
</script>